import { render, staticRenderFns } from "./VRequestCreateModal.vue?vue&type=template&id=d52626f4"
import script from "./VRequestCreateModal.vue?vue&type=script&lang=js"
export * from "./VRequestCreateModal.vue?vue&type=script&lang=js"
import style0 from "./VRequestCreateModal.vue?vue&type=style&index=0&id=d52626f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports